import { gql } from '@apollo/client';

export const GET_TRACKER_LINK_BY_SLUG = gql`
  query getTrackerLinkBySlug($slug: String!) {
    getTrackerLinkBySlug(slug: $slug) {
      destination
      eventId
      linkId
      linkUrl
      name
      passingParameter
      slug
      totalClicks
    }
  }
`;
